import { useState } from "react";
import { feedItems } from "@/mocks/gossip";

export default function JokesSection() {
  const jokes = feedItems.filter((f) => f.type === "joke");
  const [likedSet, setLikedSet] = useState<Set<number>>(new Set());

  const toggle = (id: number) => {
    setLikedSet((prev) => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  return (
    <section id="jokes" className="scroll-mt-24 bg-gradient-to-b from-background-50 to-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-700">
              <i className="ri-emotion-laugh-fill"></i>
              沙雕现场
            </span>
            <h2 className="mt-3 font-display text-3xl font-black text-foreground-900 md:text-4xl">
              笑到隔壁投诉的沙雕段子
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-7 text-foreground-500 md:text-base">
              今日份离谱行为大赏，来自热心网友的真实投稿，越看越上头。
            </p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-2">
          {jokes.map((item) => (
            <article
              key={item.id}
              className="flex flex-col rounded-3xl border border-background-200 bg-primary-500 p-6 text-background-50 transition-all hover:-translate-y-1 hover:shadow-soft md:p-8"
            >
              <div className="flex items-center justify-between">
                <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-50/20 px-3 py-1 text-xs font-semibold">
                  <i className="ri-quill-pen-fill"></i>
                  {item.tag} · {item.topic.replace(/[#]/g, "")}
                </span>
                <i className="ri-chat-quote-fill text-3xl text-background-50/30"></i>
              </div>
              <p className="mt-5 flex-1 text-base leading-8 md:text-lg">{item.content}</p>
              <div className="mt-6 flex items-center justify-between border-t border-background-50/20 pt-5">
                <div className="flex items-center gap-2">
                  <img
                    src={item.avatar}
                    alt={item.author}
                    className="h-9 w-9 rounded-full border-2 border-background-50/40 object-cover"
                    loading="lazy"
                  />
                  <span className="whitespace-nowrap text-xs font-medium text-background-50/90">{item.author}</span>
                </div>
                <button
                  onClick={() => toggle(item.id)}
                  aria-label="点赞"
                  className={`flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-semibold transition-colors ${
                    likedSet.has(item.id)
                      ? "bg-background-50 text-primary-600"
                      : "bg-background-50/20 text-background-50 hover:bg-background-50/30"
                  }`}
                >
                  <i className={likedSet.has(item.id) ? "ri-heart-3-fill" : "ri-heart-3-line"}></i>
                  笑到打鸣
                </button>
              </div>
            </article>
          ))}

          <article className="flex flex-col justify-center rounded-3xl border-2 border-dashed border-secondary-300 bg-secondary-50 p-6 md:p-8">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-secondary-200 text-secondary-800">
              <i className="ri-mic-fill text-2xl"></i>
            </span>
            <h3 className="mt-4 font-display text-xl font-bold text-foreground-900">
              你也遇到离谱事了？
            </h3>
            <p className="mt-2 text-sm leading-7 text-foreground-600">
              把你的沙雕日常、社死现场、离谱遭遇投稿过来，下一个全网流传的段子可能就是你的。
            </p>
            <a
              href="#newsletter"
              className="mt-5 inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-md bg-secondary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-secondary-600"
            >
              我要投稿
              <i className="ri-arrow-right-line"></i>
            </a>
          </article>
        </div>
      </div>
    </section>
  );
}